module.exports = __webpack_public_path__ + "assets/fonts/Georgia-Italic.055156d5.ttf";